import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section aria-label="Garanzia soddisfatti o rimborsati" className="bg-white" data-id="element-101" data-mp="1o46konudlsx5">
      <div className="mx-auto flex max-w-3xl flex-col items-center px-5 py-16 text-center lg:py-20" style={{
      paddingTop: "11px",
      paddingBottom: "23px"
    }} data-id="element-102" data-mp="223ekniyd552e">
        <span className="flex h-16 w-16 items-center justify-center rounded-full bg-perf/15" data-id="element-103" data-mp="1x4uzvlvi9zbm">
          <ShieldCheckIcon className="h-8 w-8 text-perf-deep" aria-hidden="true" data-id="element-104" data-mp="19fipiiofzl7q" />
        </span>
        <h2 className="mt-6 font-display text-4xl font-extrabold uppercase leading-none text-navy sm:text-5xl" data-id="element-105" data-mp="14gz2sg20y5eb">
          Garanzia soddisfatti o rimborsati di 7 giorni
        </h2>
        <p className="mt-5 text-[17px] leading-relaxed text-navy/75" data-id="element-106" data-mp="1edke1j4n0cql">
          Se durante i primi 7 giorni decidi che IL SISTEMA TRIATHLON FULL DISTANCE™ non è adatto alle tue
          esigenze, puoi richiedere il rimborso secondo i termini e le condizioni della garanzia.
        </p>
        <p className="mt-4 text-[17px] leading-relaxed text-navy/75" data-id="element-107" data-mp="p01hw9gad5as">
          Puoi esplorare i materiali e valutarne l'utilità per la tua preparazione senza assumerti un impegno
          economico a lungo termine.
        </p>
        <p className="mt-6 text-sm font-bold uppercase tracking-[0.2em] text-navy" data-id="element-108" data-mp="yqmbtjl0llnd">
          SIGMA SMART™ mette a disposizione un sistema digitale organizzato per aiutarti a pianificare,
          monitorare e preparare il tuo percorso verso la lunga distanza.
        </p>
      </div>
    </section>;
}